<template lang="pug">
  v-container.postal-container.mt-2.pa-0(fluid)
    v-container#postal-victim.postal-victim.pa-0(fluid justify-center)
      v-container.postal.px-0.mt-3.pb-0(fluid)
        v-row.header
          v-col.pt-0.pr-0(d-flex xs=5 sm=4)
            v-col.pa-0(d-flex)
              v-card.justify-center.align-center(d-flex flat)
                img.info(src="../../static/logo.png")
          v-col.pt-0.folio-container(d-flex xs=12 sm=8)
            v-card.fill.align-center(flat)
              h1.head.title {{ record.victimData.disappearanceMun ? record.victimData.disappearanceMun : 'Entidad' }}
              p.head.subtitle.main-text.pl-2.mr-3(fill-height align="center") Folio {{ record.folio ? `# ${record.folio}`: '' }}

        v-row.pl-3.pr-3.pt-1.aggression(d-flex fill-height align-content-center)
          v-col(d-flex xs=5 sm=5)
            v-row
              v-col.mb-3(d-flex xs=12 sm=12)
                v-card(flat d-flex).pr-2
                  img.mt-3(width="100%" title="Cambiar imagen" fluid alt="profile img" v-if="(record.victimData.photo != '')" :src="record.victimData.photo")
                  img.mt-3(width="100%" title="Cambiar imagen" fluid alt="profile img" v-else src="static/upload-icon.png")

              v-col.border.pb-1(d-flex xs=12 sm=12 align="center")
                p.black-content-title.mb-0 {{ record.narrative.perpetrators.perpetratorType.length > 0 ? record.narrative.perpetrators.perpetratorType.join(", ") : "Se desconoce" }}
              v-col.mb-4.mxh-30.py-1(d-flex xs=12 sm=12 align="center")
                p.info-title.pt-1 Victimarios

          v-col.pl-3.align-center(xs=7)
            v-row.mx-0.where(justify="center")
              v-col.border.pl-2.py-1(d-flex xs=11 sm=11 align="center")
                p.black-content-title-victim {{ record.victimData.name }}
              v-col.py-1(d-flex xs=12 sm=11 align="center")
                p.info-title.pt-1 Nombre de la víctima
                  v-row.mx-0.where

            v-row.mx-0.where(justify="center")
              v-col.border.pl-2.py-1(d-flex xs=10 sm=10 align="center")
                p.content-title-victim {{ formatDate(record.victimData.disappearanceDate) }}
              v-col.py-1(d-flex xs=12 sm=12 align="center")
                p.info-title.pt-1 Fecha de desaparición
                  v-row.mx-0.where

            v-row.mx-0.where(justify="center")
              v-col.border.pl-2.py-1(d-flex xs=9 sm=9 align="center")
                p.content-title-victim {{ record.victimData.disappearanceMun.lenght > 22 ? record.victimData.disappearanceMun.substr(0,19) + '...' : record.victimData.disappearanceMun}} {{record.victimData.disappearanceMun !== '' ? ',' : ''}} {{record.victimData.disappearanceState ? record.victimData.disappearanceState : '' }}
              v-col.py-1(d-flex xs=12 align="center")
                p.info-title.pt-1 Lugar de los hechos
                  v-row.mx-0.where

            v-row.mx-0.where(justify="center")
              v-col.border.py-1(d-flex xs=8 sm=8 align="center")
                p.content-title-victim {{ record.victimData.disappearanceAge }}
              v-col.py-1(d-flex xs=12 sm=12 align="center")
                p.info-title.pt-1 Edad al momento de desaparición
                  v-row.mx-0.where

          v-row.details
            v-col.my-0.pb-0(xs=12 sm=12)
              p.details-title.complaints.px-4.bold.pt-1.pb-1 Denuncias
            v-col.my-0.pt-0(xs=12 sm=12)
              p.details-box
                span.small(v-for="(report, i) in record.narrative.policeReports") {{report.reportDate.day}}{{report.reportDate.day && report.reportDate.month ? '-' : ''}}{{report.reportDate.month}}{{report.reportDate.month && report.reportDate.year ? ('-' + report.reportDate.year + '.') : ''}} {{report.reportPlace ? report.reportPlace.name + '.' : ''}} {{report.reportNumberDetails ? ('Número: ' + report.reportNumberDetails) : ''}}

          v-row.details
            v-col.my-0.py-0(xs=12 sm=12)
              p.details-title.px-4.bold.pt-1.pb-1 Antecedentes
            v-col.my-0.py-0(xs=12 sm=12)
              p.details-box {{ record.summary.background }}

          v-row.details
            v-col.my-0.pb-0(xs=12 sm=12)
              p.details-title.px-4.bold.pt-1.pb-1 Hechos
            v-col.my-0.pt-0(xs=12 sm=12)
              p.details-box {{ record.summary.facts }}

</template>

<script>
import * as _ from "lodash";

export default {
  name: "VictimPostal",
  computed: {
    record() {
      return this.$store.state.record;
    }
  },
  methods: {
    formatDate(value) {
      let month =
        value.month.length < 2 && value.month !== ""
          ? `0${value.month}`
          : value.month;
      let day =
        value.day.length < 2 && value.day !== "" ? `0${value.day}` : value.day;

      let date = day !== "" ? `${day}` : "";
      date += day !== "" && month !== "" ? "/" : "";
      date += month !== "" ? `${month}` : "";
      date += month !== "" && value.year !== "" ? "/" : "";
      date += value.year !== "" ? `${value.year}` : "";

      return date;
    },
    showSelections(obj) {
      let selected = [];
      _.forEach(obj, val => {
        if (val.isSelected) {
          selected.push(val.text);
        }
      });
      return selected.join(", ");
    }
  }
};
</script>

<style src="./postal.scss" lang="scss"></style>
